if (!customElements.get('kies-product-spacing')) {
  customElements.define('kies-product-spacing', class extends HTMLElement {
    connectedCallback() {
      this.stack = this.parentElement.querySelector(':scope > .group-block > .group-block-content');
      if (!this.stack || window.Shopify?.designMode) return;

      this.items = new Set();
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.updateSpacing());
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.stack);
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.stack, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      this.schedule();
    }

    updateSpacing() {
      this.frame = 0;
      if (!this.isConnected) return;

      const candidates = new Set(this.stack.querySelectorAll(
        ':scope > .shopify-app-block[id*="__affirm_pay_over_time_messaging_product_block_"], ' +
        ':scope > .shopify-app-block[id*="__hulk_product_options_option_block_"], ' +
        ':scope > .productView-moreItem'
      ));
      for (const item of this.items) {
        if (!candidates.has(item)) {
          this.resizeObserver.unobserve(item);
          item.removeAttribute('data-kies-empty-product-block');
        }
      }
      for (const item of candidates) {
        if (!this.items.has(item)) this.resizeObserver.observe(item);
      }
      this.items = candidates;

      const layout = getComputedStyle(this.stack);
      const gap = layout.display === 'flex' && layout.flexDirection === 'column'
        ? Number.parseFloat(layout.rowGap) || 0
        : 0;
      const value = `${gap}px`;
      if (this.stack.style.getPropertyValue('--kies-product-block-gap') !== value) {
        this.stack.style.setProperty('--kies-product-block-gap', value);
      }

      for (const item of this.items) {
        const empty = gap > 0 && item.getClientRects().length > 0 &&
          item.getBoundingClientRect().height === 0 &&
          !Array.from(item.querySelectorAll('*')).some(child => {
            const bounds = child.getBoundingClientRect();
            return bounds.width > 0 && bounds.height > 0;
          });
        item.toggleAttribute('data-kies-empty-product-block', empty);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.items?.forEach(item => item.removeAttribute('data-kies-empty-product-block'));
      this.stack?.style.removeProperty('--kies-product-block-gap');
      this.frame = 0;
    }
  });
}

